import AddComment from './AddComment';

export default AddComment;
